<p-panel header="Container {{ container.id }}" [toggleable]="true" [collapsed]="true">
    <p-fluid>
        <form [formGroup]="form">
            <div class="grid">
                <!-- Linked item -->
                <div class="col-12">
                    <p class="text-xs font-semibold text-500 uppercase mt-0 mb-0">Linked Item</p>
                </div>

                <div class="col-12 md:col-6 lg:col-4">
                    <p-ifta-label>
                        <p-select
                            class="p-fluid"
                            inputId="item_{{ container.id }}"
                            formControlName="item"
                            optionLabel="itemCode"
                            optionValue="iri"
                            placeholder="Select an item"
                            [showClear]="true"
                            [options]="forecast.planningParameter.items"
                        ></p-select>
                        <label for="item_{{ container.id }}">Item</label>
                    </p-ifta-label>
                </div>

                <!-- Static container fields -->
                <div class="col-12">
                    <p class="text-xs font-semibold text-500 uppercase mt-3 mb-0">Container Fields</p>
                </div>

                <div class="col-12 md:col-6 lg:col-4">
                    <p-ifta-label>
                        <input pInputText id="loadingPort_{{ container.id }}"
                               formControlName="unLoCodeLoadingPort"
                               class="w-full"/>
                        <label for="loadingPort_{{ container.id }}">UN/LOCODE Loading Port</label>
                    </p-ifta-label>
                </div>

                <div class="col-12 md:col-6 lg:col-4">
                    <p-ifta-label>
                        <input pInputText id="destinationPort_{{ container.id }}"
                               formControlName="unLoCodeDestinationPort"
                               class="w-full"/>
                        <label for="destinationPort_{{ container.id }}">UN/LOCODE Destination Port</label>
                    </p-ifta-label>
                </div>

                <div class="col-12 md:col-6 lg:col-4">
                    <p-ifta-label>
                        <input pInputText id="mbol_{{ container.id }}"
                               formControlName="masterBillOfLadingReference"
                               class="w-full"/>
                        <label for="mbol_{{ container.id }}">Master Bill of Lading Reference</label>
                    </p-ifta-label>
                </div>

                <div class="col-12 md:col-6 lg:col-4">
                    <p-ifta-label>
                        <input pInputText id="carrier_{{ container.id }}"
                               formControlName="oceanCarrierCode"
                               class="w-full"/>
                        <label for="carrier_{{ container.id }}">Ocean Carrier Code</label>
                    </p-ifta-label>
                </div>

                <div class="col-12 md:col-6 lg:col-4">
                    <p-ifta-label>
                        <p-inputNumber
                            id="moduleWattage_{{ container.id }}"
                            formControlName="moduleWattage"
                            class="w-full"
                            [min]="0"
                            suffix="W"
                        />
                        <label for="moduleWattage_{{ container.id }}">Module wattage</label>
                    </p-ifta-label>
                </div>

                <div class="col-12 md:col-6 lg:col-4">
                    <p-ifta-label>
                        <input pInputText id="purchaseOrderId_{{ container.id }}"
                               formControlName="purchaseOrderId"
                               class="w-full"/>
                        <label for="purchaseOrderId_{{ container.id }}">Purchase Order ID</label>
                    </p-ifta-label>
                </div>

                <div class="col-12 md:col-6 lg:col-4">
                    <p-ifta-label>
                        <p-datePicker
                               id="etdFactory_{{ container.id }}"
                               formControlName="etdFactory"
                               class="w-full"
                               dateFormat="yy-mm-dd"
                        />
                        <label for="etdFactory_{{ container.id }}">ETD Factory</label>
                    </p-ifta-label>
                </div>

                <div class="col-12 md:col-6 lg:col-4">
                    <p-ifta-label>
                        <p-datePicker
                            id="etdPort_{{ container.id }}"
                            formControlName="etdPort"
                            class="w-full"
                            dateFormat="yy-mm-dd"
                        />
                        <label for="etdPort_{{ container.id }}">ETD Port</label>
                    </p-ifta-label>
                </div>

                <div class="col-12 md:col-6 lg:col-4">
                    <p-ifta-label>
                        <p-datePicker
                            id="etaDestinationPort_{{ container.id }}"
                            formControlName="etaDestinationPort"
                            class="w-full"
                            dateFormat="yy-mm-dd"
                        />
                        <label for="etaDestinationPort_{{ container.id }}">ETA Destination Port</label>
                    </p-ifta-label>
                </div>

                <div class="col-12 md:col-6 lg:col-4">
                    <p-ifta-label>
                        <p-datePicker
                            id="inbondDate_{{ container.id }}"
                            formControlName="inbondDate"
                            class="w-full"
                            dateFormat="yy-mm-dd"
                        />
                        <label for="inbondDate_{{ container.id }}">Inbond Date</label>
                    </p-ifta-label>
                </div>

                <!-- Custom fields -->
                @if (customFields.length > 0) {
                    <div class="col-12">
                        <p class="text-xs font-semibold text-500 uppercase mt-3 mb-0">Custom Fields</p>
                    </div>

                    <ng-container formGroupName="customFields">
                        @for (cf of customFields; track cf.id) {
                            <div class="col-12 md:col-6 lg:col-4">
                                <p-ifta-label>
                                    <input pInputText id="cf_{{ container.id }}_{{ cf.id }}"
                                           [formControlName]="cf.id"
                                           class="w-full"/>
                                    <label for="cf_{{ container.id }}_{{ cf.id }}">{{ cf.name }}</label>
                                </p-ifta-label>
                            </div>
                        }
                    </ng-container>
                }
            </div>
        </form>
    </p-fluid>
</p-panel>
